import { useNavigate } from 'react-router-dom';
import { useExamMode } from '../context/ExamModeContext';

// Persistent banner rendered at the top of every signed-in screen when an exam
// attempt is active. Makes it impossible to forget you are in locked Exam Mode,
// and gives a quick path to the End Attempt screen.
export function ExamModeBanner() {
  const { active, session } = useExamMode();
  const navigate = useNavigate();
  if (!active || !session) return null;

  return (
    <div className="sticky top-0 z-30 bg-red-700 text-white px-4 py-2.5 shadow-md">
      <div className="max-w-[460px] mx-auto flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <svg
            className="w-4 h-4 flex-shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            aria-hidden
          >
            <rect x="3" y="11" width="18" height="11" rx="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <span className="font-semibold uppercase tracking-wider text-xs">Exam Mode</span>
          <span className="truncate text-white/85">
            {session.paperTitle || 'attempt in progress'}
          </span>
        </div>
        <button
          onClick={() => navigate('/app/exam/end')}
          className="text-xs underline whitespace-nowrap hover:text-white/80"
        >
          End attempt
        </button>
      </div>
    </div>
  );
}
